module.exports = __webpack_public_path__ + "static/media/comic-carton-02.c1bd3442.png";